<template>
  <div>
    <v-dialog
      v-model="showCarrierModal"
      max-width="600"
      @input="resetCarrierModal"
    >
      <v-card class="popup-card" elevation="1">
        <v-card-title
          class="popupHeadline d-flex justify-center"
          style="font-size: 16px"
        >
          <h3>{{ $t('buttons.callCarrier') }}</h3>
        </v-card-title>
        <v-divider class="mb-4" />

        <ValidationObserver
          v-slot="{ handleSubmit }"
          ref="carrierModalObserver"
        >
          <v-card-text>
            <form @submit.prevent="handleSubmit(submitCarrier)">
              <h2 class="form-label mt-4 mb-8">
                {{ $t('titles.shipmentPickupAddress') }}
              </h2>
              <v-row class="mt-2">
                <FormElement
                  v-for="(element, index) in carrierFormItems"
                  :key="
                    element.key.parent + '_' + element.key.child + '_' + index
                  "
                  v-model="$data[element.key.parent][element.key.child]"
                  :validationLabel="$t(element.validationLabel)"
                  :formLabel="$t(element.formLabel)"
                  :onChange="element.onChange"
                  :formType="element.formType"
                  :lg="element.lg"
                  :cols="element.cols"
                  :hidden="element.hidden"
                  :rules="element.rules"
                  :labelShown="element.labelShown"
                  :topLabel="element.topLabel"
                  :active="element.active"
                  :placeholder="$t(element.placeholder)"
                  :disabled="isSupplier"
                />
                <v-col
                  style="padding: 1% 12px !important"
                  class="form-label"
                  cols="12"
                >
                  {{ $t('labels.supplierCarrier.plannedCarrierDateRange')
                  }}<span class="error-label">*</span>
                </v-col>
                <FormElement
                  v-for="(element, index) in carrierFormDateRange"
                  :key="
                    element.key.parent + '_' + element.key.child + '_' + index
                  "
                  v-model="$data[element.key.parent][element.key.child]"
                  :validationLabel="$t(element.validationLabel)"
                  :rules="isSupplier ? '' : element.rules"
                  :formLabel="$t(element.formLabel)"
                  :onChange="element.onChange"
                  :formType="element.formType"
                  :lg="element.lg"
                  :cols="element.cols"
                  :hidden="element.hidden"
                  :labelShown="false"
                  :topLabel="false"
                  :active="element.active"
                  :placeholder="$t(element.placeholder)"
                  :disabled="isSupplier"
                />
              </v-row>
              <v-divider />
              <h2 class="form-label my-4">
                {{ $t('titles.supplierCarrierInformation') }}
              </h2>
              <v-row class="my-5">
                <FormElement
                  v-for="(element, index) in supplierCarrierInformation"
                  :key="
                    element.key.parent + '_' + element.key.child + '_' + index
                  "
                  v-model="$data[element.key.parent][element.key.child]"
                  :validationLabel="$t(element.validationLabel)"
                  :formLabel="$t(element.formLabel)"
                  :onChange="element.onChange"
                  :formType="element.formType"
                  :lg="element.lg"
                  :cols="element.cols"
                  :hidden="element.hidden"
                  :labelShown="element.labelShown"
                  :topLabel="element.topLabel"
                  :active="element.active"
                  :placeholder="$t(element.placeholder)"
                  :disabled="!isSupplier"
                />
                <v-col
                  style="padding: 1% 12px !important"
                  class="form-label"
                  cols="12"
                >
                  {{ $t('labels.supplierCarrier.plannedShipmentDateRange') }}
                </v-col>
                <FormElement
                  v-for="(element, index) in supplierCarrierDateRange"
                  :key="
                    element.key.parent + '_' + element.key.child + '_' + index
                  "
                  v-model="$data[element.key.parent][element.key.child]"
                  :validationLabel="$t(element.validationLabel)"
                  :formLabel="$t(element.formLabel)"
                  :onChange="element.onChange"
                  :formType="element.formType"
                  :lg="element.lg"
                  :cols="element.cols"
                  :hidden="element.hidden"
                  :labelShown="element.labelShown"
                  :topLabel="element.topLabel"
                  :active="element.active"
                  :placeholder="$t(element.placeholder)"
                  :disabled="!isSupplier"
                />
              </v-row>
              <v-alert type="warning">{{
                $t('description.carrierCostWarning')
              }}</v-alert>
              <v-card-actions class="text-center justify-center">
                <v-btn
                  style="
                    color: #fff;
                    text-transform: unset !important;
                    background-color: #0077d5;
                    padding: 1vh 1vh;
                    border-radius: 30px !important;
                    font-weight: bolder;
                    font-size: medium;
                  "
                  elevation="0"
                  type="submit"
                  class="darken-1"
                >
                  {{
                    $t(`buttons.${isCarrierEdit ? 'update' : 'callCarrier'}`)
                  }}
                </v-btn>
                <v-btn
                  style="
                    color: #fff;
                    text-transform: unset !important;
                    background-color: var(--red);
                    padding: 1vh 1vh;
                    border-radius: 30px !important;
                    font-weight: bolder;
                    font-size: medium;
                  "
                  elevation="0"
                  class="darken-2"
                  @click="resetCarrierModal"
                >
                  {{ $t('buttons.close') }}
                </v-btn>
              </v-card-actions>
            </form>
          </v-card-text>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <!-- SUBMIT ADDRESS FORM MODAL -->
    <v-dialog
      v-model="cancelOrderModal"
      max-width="600"
      @input="resetCancelModal"
    >
      <v-card class="popup-card" elevation="1">
        <v-card-title
          class="popupHeadline d-flex justify-center"
          style="font-size: 16px"
        >
          <h3>{{ $t('buttons.cancelOrder') }}</h3>
        </v-card-title>
        <v-divider class="mb-4" />

        <ValidationObserver v-slot="{ handleSubmit }" ref="cancelModalObserver">
          <v-card-text>
            <form @submit.prevent="handleSubmit(cancelOrder)">
              <v-row>
                <FormElement
                  :vertical="true"
                  v-model="selectedReason"
                  :validationLabel="$t('labels.cancelReason')"
                  rules="required"
                  :topLabel="true"
                  :labelShown="false"
                  :lg="12"
                  :formType="{
                    name: 'multipleSelect',
                    items: {
                      data: cancelReasons,
                      value: 'value',
                      text: 'name',
                    },
                  }"
                  :placeholder="$t('labels.cancelReason')"
                />
                <FormElement
                  v-model="cancelDescription"
                  :lg="12"
                  rules="required"
                  :validationLabel="$t('labels.cancelDescription')"
                  :labelShown="false"
                  :placeholder="$t('labels.cancelDescription')"
                  :formType="{ name: 'textarea' }"
                />
              </v-row>
              <v-card-actions class="text-center justify-center">
                <v-btn
                  style="
                    color: #fff;
                    text-transform: unset !important;
                    background-color: #0077d5;
                    padding: 1vh 1vh;
                    border-radius: 30px !important;
                    font-weight: bolder;
                    font-size: medium;
                  "
                  elevation="0"
                  type="submit"
                  class="darken-1"
                >
                  {{ $t('buttons.approve') }}
                </v-btn>
                <v-btn
                  style="
                    color: #fff;
                    text-transform: unset !important;
                    background-color: var(--red);
                    padding: 1vh 1vh;
                    border-radius: 30px !important;
                    font-weight: bolder;
                    font-size: medium;
                  "
                  elevation="0"
                  class="darken-2"
                  @click="resetCancelModal"
                >
                  {{ $t('buttons.close') }}
                </v-btn>
              </v-card-actions>
            </form>
          </v-card-text>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <!-- SUBMIT ADDRESS FORM MODAL END -->

    <ConfirmationModal
      :title="$t('labels.warning')"
      :message="$t('messages.addVolumeWarning')"
      :confirm="confirmation.onConfirm"
      v-model="confirmation.visible"
    />
    <v-dialog v-model="addOrderModal" max-width="1200">
      <QuickCreateOrder v-if="addOrderModal" />
    </v-dialog>
    <!-- Page content -->
    <v-card elevation="1">
      <div class="flex w-full rounded-tl-sm rounded-tr-sm">
        <v-card-title style="color: var(--darkBlue)">
          <v-row align="center">
            <!-- Trick -->
            <v-col
              lg="5"
              xl="5"
              v-if="$vuetify.breakpoint.lg || $vuetify.breakpoint.xl"
            ></v-col>
            <v-col class="text-center" cols="12" lg="2" xl="2">
              <h3>{{ $t('labels.orders') }}</h3>
            </v-col>
            <v-col
              cols="12"
              lg="5"
              xl="5"
              style="gap: 10px"
              class="d-flex flex-sm-row flex-column justify-center align-center justify-lg-end"
            >
              <v-btn
                v-if="Object.values(filters).some((item) => !!item)"
                variant="tonal"
                color="#0177d4"
                class="button"
                style="color: white"
                @click="resetFilter"
              >
                <v-icon>mdi-trash-can</v-icon>
                {{ $t('buttons.clearFilter') }}
              </v-btn>
              <v-tooltip bottom v-if="!isSupplier">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    style="color: white; background-color: var(--pink)"
                    class="button"
                    v-bind="attrs"
                    v-on="on"
                    @click="addOrderModal = true"
                  >
                    <v-icon>mdi-plus</v-icon>
                    {{ $t('buttons.createOrder') }}
                  </v-btn>
                </template>
                <span>{{ $t('buttons.createOrder') }}</span>
              </v-tooltip>
              <RefreshButton :refreshFunction="getTableList"></RefreshButton>
            </v-col>
          </v-row>
        </v-card-title>
      </div>

      <v-divider />

      <v-card-text fill-height fluid>
        <v-row align="center" class="d-flex">
          <v-col cols="12" class="align-center">
            <v-row class="align-center pt-3">
              <FormElement
                v-for="(element, index) in filters_formItems"
                :key="
                  element.key.parent + '_' + element.key.child + '_' + index
                "
                :willBeEliminated="false"
                v-model="$data[element.key.parent][element.key.child]"
                :validationLabel="$t(element.validationLabel)"
                :rules="element.rules"
                :formLabel="$t(element.formLabel)"
                :onChange="element.onChange"
                :formType="element.formType"
                :lg="element.lg"
                :md="element.md"
                :sm="element.sm"
                :xl="element.xl"
                :cols="element.cols"
                :hidden="element.hidden"
                :labelShown="false"
                :topLabel="true"
                :active="element.active"
                :placeholder="$t(element.placeholder)"
                @input="getSearchDebounced"
              />
            </v-row>
          </v-col>

          <v-row class="align-center"> </v-row>
        </v-row>

        <v-data-table
          :headers="headers"
          :items="tableData"
          :loading="loadings.table"
          :options.sync="options"
          :hide-default-footer="true"
          :footer-props="{
            disablePagination: true,
            disableItemsPerPage: true,
          }"
          :no-data-text="$t('description.noList')"
          ref="orderList"
        >
          <!-- eslint-disable -->

          <template v-slot:item.Customer="{ item }">
            <div
              class="pt-2 d-flex flex-column justify-center items-center align-center"
            >
              <img
                :src="item.CustomerLogo"
                alt="Logo"
                style="width: 60px; height: auto"
              />
              {{ item.Customer }}
            </div>
          </template>

          <template v-slot:item.Carrier="{ item }">
            <div
              class="pt-2 d-flex flex-column justify-center items-center align-center"
            >
              <img
                :src="item.CarrierLogo"
                alt="Logo"
                style="width: 60px; height: auto"
              />
              {{ item.Carrier }}
            </div>
          </template>
          <template v-slot:item.Source="{ item }">
            <div
              class="pt-2 d-flex flex-column justify-center items-center align-center"
            >
              <img
                :src="item.SourceCompanyLogo"
                alt="Logo"
                style="width: 60px; height: auto"
              />
              {{ item.SourceCompany }}
            </div>
          </template>
          <template class="w-min" v-slot:item.FromToWhere="{ item }">
            <div style="white-space: normal; word-wrap: break-word">
              {{ item.From }}
            </div>
            <span>-</span>
            <div style="white-space: normal; word-wrap: break-word">
              {{ item.To }}
            </div>
          </template>

          <template class="w-min" v-slot:item.CarrierLogo="{ item }">
            <div>
              <img
                :src="item.CarrierLogo"
                alt="Logo"
                style="width: 50px; height: auto"
              />
            </div>
          </template>
          <template v-slot:item.ShipmentType="{ item }">
            <div style="white-space: normal; word-wrap: break-word">
              {{ item.ShipmentType }}
            </div>
            <span v-if="item.ShipmentType !== 'Express'">
              <span>-</span>
              <div style="white-space: normal; word-wrap: break-word">
                {{ item.LoadingType }}
              </div>
            </span>
          </template>
          <template v-slot:item.CreatedOnUtc="{ item }">
            {{ convertToLocal(item.CreatedOnUtc) }}
          </template>
          <template v-slot:item.OrderType="{ item }">
            {{ orderTypes[item.OrderType] }}
          </template>
          <template v-slot:item.OrderStatus="{ item }">
            <v-chip
              v-if="item.OrderStatus == 0"
              style="font-weight: 600"
              class="ma-2"
              small
              color="#c5f4db"
              text-color="#2b3838"
            >
              {{ $t('labels.labelsOrderStatuses.detail') }}
            </v-chip>
            <v-chip
              v-if="item.OrderStatus == 2"
              style="font-weight: 600"
              class="ma-2"
              small
              color="#c5f4db"
              text-color="#2b3838"
            >
              {{ $t('labels.labelsOrderStatuses.payment') }}
            </v-chip>
            <v-chip
              v-if="item.OrderStatus == 1"
              style="font-weight: 600"
              class="ma-2"
              small
              color="#c5f4db"
              text-color="#2b3838"
            >
              {{ $t('labels.labelsOrderStatuses.paymentApproved') }}
            </v-chip>
            <v-chip
              v-if="item.OrderStatus == 3"
              style="font-weight: 600"
              class="ma-2"
              small
              color="#c5f4db"
              text-color="#2b3838"
            >
              {{ $t('labels.labelsOrderStatuses.approved') }}
            </v-chip>
            <v-chip
              v-if="item.OrderStatus == 4"
              style="font-weight: 600"
              class="ma-2"
              small
              color="#c5f4db"
              text-color="#2b3838"
            >
              {{ $t('labels.labelsOrderStatuses.loaded') }}
            </v-chip>
            <v-chip
              v-if="item.OrderStatus == 5"
              style="font-weight: 600"
              class="ma-2"
              small
              color="#c5f4db"
              text-color="#2b3838"
            >
              {{ $t('labels.labelsOrderStatuses.shipping') }}
            </v-chip>
            <v-chip
              v-if="item.OrderStatus == 6"
              style="font-weight: 600"
              class="ma-2"
              small
              color="#c5f4db"
              text-color="#2b3838"
            >
              {{ $t('labels.labelsOrderStatuses.inDestination') }}
            </v-chip>
            <v-chip
              v-if="item.OrderStatus == 7"
              style="font-weight: 600"
              class="ma-2"
              small
              color="#c5f4db"
              text-color="#2b3838"
            >
              {{ $t('labels.labelsOrderStatuses.delivered') }}
            </v-chip>
            <v-chip
              v-if="item.OrderStatus == 8"
              style="font-weight: 600"
              class="ma-2"
              small
              color="#c5f4db"
              text-color="#2b3838"
            >
              {{ $t('labels.labelsOrderStatuses.archived') }}
            </v-chip>
            <v-chip
              v-if="item.OrderStatus == 9"
              class="ma-2"
              small
              color="#E72929"
              text-color="white"
              style="font-weight: 600"
            >
              {{ $t('labels.labelsOrderStatuses.canceled') }}
            </v-chip>
          </template>
          <template v-slot:item.SupplierOrderStatus="{ item }">
            <div class="d-flex justify-center">
              <div v-if="item.OrderStatus == 9">
                <v-chip
                  class="ma-2"
                  small
                  color="#E72929"
                  text-color="white"
                  style="font-weight: 600"
                >
                  {{ $t('labels.labelsOrderStatuses.canceled') }}
                </v-chip>
              </div>
              <div v-else>
                <v-chip
                  v-if="item.SupplierOrderStatus == 0"
                  style="font-weight: 600"
                  class="ma-1"
                  small
                  color="#689fd5"
                  text-color="#FFFFFF"
                >
                  {{ $t('labels.fileStatuses.notPlanned') }}
                </v-chip>
                <v-chip
                  v-if="item.SupplierOrderStatus == 1"
                  style="font-weight: 600"
                  class="ma-1"
                  small
                  color="#689fd5"
                  text-color="#FFFFFF"
                >
                  {{ $t('labels.fileStatuses.pickupPlanned') }}
                </v-chip>
                <v-chip
                  v-if="item.SupplierOrderStatus == 2"
                  style="font-weight: 600"
                  class="ma-1"
                  small
                  color="#689fd5"
                  text-color="#FFFFFF"
                >
                  {{ $t('labels.fileStatuses.inWarehouse') }}
                </v-chip>
                <v-chip
                  v-if="item.SupplierOrderStatus == 3"
                  style="font-weight: 600"
                  class="ma-1"
                  small
                  color="#689fd5"
                  text-color="#FFFFFF"
                >
                  {{ $t('labels.fileStatuses.loading') }}
                </v-chip>
                <v-chip
                  v-if="item.SupplierOrderStatus == 4"
                  style="font-weight: 600"
                  class="ma-1"
                  small
                  color="#689fd5"
                  text-color="#FFFFFF"
                >
                  {{ $t('labels.fileStatuses.invoiced') }}
                </v-chip>
                <v-chip
                  v-if="item.SupplierOrderStatus == 5"
                  style="font-weight: 600"
                  class="ma-1"
                  small
                  color="#689fd5"
                  text-color="#FFFFFF"
                >
                  {{ $t('labels.fileStatuses.atDestination') }}
                </v-chip>
                <v-chip
                  v-if="item.SupplierOrderStatus == 6"
                  style="font-weight: 600"
                  class="ma-1"
                  small
                  color="#689fd5"
                  text-color="#FFFFFF"
                >
                  {{ $t('labels.fileStatuses.delivered') }}
                </v-chip>
                <v-chip
                  v-if="item.SupplierOrderStatus === null"
                  style="font-weight: 600"
                  class="ma-1"
                  small
                  color="#689fd5"
                  text-color="#FFFFFF"
                >
                  {{ $t('labels.notAvailable') }}
                </v-chip>
              </div>
              <v-tooltip v-if="item.IsCourierNotPlanned && isSupplier" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="red"
                    class="mr-1"
                    style="font-size: 20px"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-account-tie-hat
                  </v-icon>
                </template>
                <span>{{ $t('labels.isCourierDesc') }}</span>
              </v-tooltip>
            </div>
          </template>
          <template v-slot:item.PaymentStatus="{ item }">
            <v-chip
              v-if="item.PaymentStatus === 0"
              style="font-weight: 600"
              class="ma-2"
              small
              color="#c5f4db"
              text-color="#2b3838"
            >
              {{ $t('labels.paymentCompleted') }}
            </v-chip>
            <v-chip
              v-else-if="item.PaymentStatus === 1"
              style="font-weight: 600"
              class="ma-2"
              small
              color="#f4c5c5"
              text-color="#2b3838"
            >
              {{ $t('labels.paymentIncomplete') }}
            </v-chip>
            <v-chip
              v-else-if="item.PaymentStatus === 2"
              style="font-weight: 600"
              class="ma-2"
              small
              color="#f4f4c5"
              text-color="#2b3838"
            >
              {{ $t('messages.waitingForPaymentApproval') }}
            </v-chip>
            <v-chip
              v-else-if="item.PaymentStatus === 3"
              style="font-weight: 600"
              class="ma-2"
              small
              color="#f4c5c5"
              text-color="#2b3838"
            >
              {{ $t('messages.extraPayment') }}
            </v-chip>
            <v-chip
              v-else-if="item.PaymentStatus === 4"
              style="font-weight: 600"
              class="ma-2"
              small
              color="#f4c5c5"
              text-color="#2b3838"
            >
              {{ $t('messages.returnPayment') }}
            </v-chip>
          </template>

          <template v-slot:item.actions="{ item }">
            <div class="d-flex text-start">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="#29B7B7"
                    class="mr-1"
                    style="font-size: 20px"
                    v-bind="attrs"
                    v-on="on"
                    @click="goOrderDetail(item)"
                  >
                    mdi-pencil
                  </v-icon>
                </template>
                <span>{{ $t('labels.tooltipEdit') }}</span>
              </v-tooltip>
              <v-tooltip top v-if="item.OrderStatus !== 9">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="var(--red)"
                    class="mr-1"
                    style="font-size: 20px"
                    v-bind="attrs"
                    v-on="on"
                    @click="triggerCancelOrder(item)"
                  >
                    mdi-cancel
                  </v-icon>
                </template>
                <span>{{ $t('labels.cancelOrder') }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-if="item.LabelStatus && item.OrderStatus != 9"
                    color="#29B7B7"
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                    @click="downloadTag(item)"
                    style="font-size: 20px"
                  >
                    mdi-barcode
                  </v-icon>
                </template>
                <span>{{ $t('labels.tooltipDownloadLabel') }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-if="item.OrderStatus == 2 && item.OrderStatus != 9"
                    small
                    color="#29B7B7"
                    @click="goToPayments()"
                    v-bind="attrs"
                    v-on="on"
                    class="mr-1"
                    style="font-size: 20px"
                  >
                    mdi-credit-card
                  </v-icon>
                </template>
                <span>{{ $t('buttons.goPayment') }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-if="item.OrderStatus == 7 && !item.IsArchive"
                    small
                    color="#29B7B7"
                    @click="toggleArchive(item)"
                    v-bind="attrs"
                    v-on="on"
                    class="mr-1"
                    style="font-size: 20px"
                  >
                    mdi-archive-arrow-down
                  </v-icon>
                </template>
                <span>{{ $t('buttons.setArchive') }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-if="item.IsArchive"
                    small
                    color="#29B7B7"
                    @click="toggleArchive(item)"
                    v-bind="attrs"
                    v-on="on"
                    class="mr-1"
                    style="font-size: 20px"
                  >
                    mdi-archive-arrow-up
                  </v-icon>
                </template>
                <span>{{ $t('buttons.unarchive') }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-if="
                      item.OrderStatus == 7 &&
                      (userRole == 'Customer' ||
                        userRole == 'PendingCustomer') &&
                      item.IsRate &&
                      item.OrderStatus != 9
                    "
                    small
                    color="#29B7B7"
                    @click="goRateScreen(item)"
                    v-bind="attrs"
                    v-on="on"
                    style="font-size: 20px"
                  >
                    mdi-star
                  </v-icon>
                </template>
                <span>{{ $t('labels.rate') }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    color="#29B7B7"
                    class="mr-1"
                    style="font-size: 20px"
                    v-bind="attrs"
                    v-on="on"
                    @click="messageToUser(item.Id)"
                  >
                    mdi-email
                  </v-icon>
                </template>
                <span>{{ $t('buttons.sendAMessage') }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-if="
                      (userRole == 'Customer' ||
                        userRole == 'PendingCustomer') &&
                      item.OrderStatus == 3
                    "
                    small
                    color="#29B7B7"
                    class="mr-1"
                    style="font-size: 20px"
                    v-bind="attrs"
                    v-on="on"
                    @click="callCarrier(item)"
                  >
                    mdi-account-tie-hat
                  </v-icon>
                </template>
                <span>{{ $t('buttons.callCarrier') }}</span>
              </v-tooltip>

              <BlockUser
                v-if="isSupplier"
                :customer="{
                  customerId: item.CustomerCompanyId,
                  fullName: item.Customer,
                }"
                :dataTable="true"
              />
            </div>
          </template>
        </v-data-table>

        <div class="text-xs-center pt-2 md4 lg4">
          <v-row align="center">
            <v-col md="3" class="ml-md-auto">
              <v-pagination
                @input="paginationChangeHandler"
                :value="page"
                :length="pages"
                :total-visible="10"
                circle
              ></v-pagination>
            </v-col>
            <v-col md="2" class="ml-md-auto">
              <v-select
                v-model="rowsPerPage"
                :items="perPageValues"
                :label="$t('labels.selectItemsPerPage')"
                item-value="value"
                item-text="name"
                outlined
                dense
                @change="changeItemsPerPage()"
                rounded
              >
              </v-select>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import OrderService from '../services/OrderService';
import RefreshButton from '../components/RefreshButton.vue';
import MessageServices from '../services/MessageServices';
import BlockUser from '../components/BlockUser.vue';
import FormElement from '../components/FormElement.vue';
import {
  getCountries,
  convertVolumeToBoxes,
  getCurrencyTypes,
  extractDateFromObject,
} from '../utils/constants';
import rules, {
  company,
  getLabelCustomerReferenceRules,
  phone,
} from '../utils/validationRules';
import CompanyServices from '../services/CompanyServices';
import AddVolume from '../views/OfferScreens/AddVolume.vue';
import ConfirmationModal from '../components/General/ConfirmationModal.vue';
import SearchServices from '../services/SearchServices';

import { openRouteInNewTab } from '../utils/common';
import CarrierService from '../services/CarrierService';
import QuickCreateOrder from './QuickCreateOrder.vue';

const { ...INITIAL_FILTERS } = {
  StartDate: null,
  EndDate: null,
  OrderStatus: null,
  PaymentStatus: null,
  TransportType: null,
  HasBoxes: null,
  CompanyName: null,
  RefNo: null,
  TrackingNo: null,
  From: null,
  To: null,
  Id: null,
  SupplierOrderStatus: null,
  OrderType: null
};

export default {
  data: () => ({
    options: {
      itemsPerPage: 15,
    },
    tableData: [],
    headers: [],
    userRole: '',
    top: 15,
    search: '',
    loadings: {
      table: false,
      select: false,
      send: false,
    },
    countryItems: [],
    orderStatuses: [],
    supplierOrderStatuses: [],
    shipmentTypes: [],
    totalItems: 0,
    debounceTimeout: null,
    cancelOrderModal: false,
    selectedReason: null,
    selectedOrder: null,
    cancelDescription: '',
    rowsPerPage: 15,
    page: 1,
    perPageValues: [
      {
        name: '10',
        value: 10,
      },
      {
        name: '15',
        value: 15,
      },
      {
        name: '30',
        value: 30,
      },
      {
        name: '50',
        value: 50,
      },
      {
        name: '100',
        value: 100,
      },
    ],
    cancelReasons: [],
    isSupplier: false,
    isAdmin: false,

    orderTypes: ['Manuel', 'Etsy', 'Amazon', 'API'],

    // Order
    addOrderModal: false,
    form: {
      ServiceType: 1,
      ExportImportType: 1,
      volumes: [],
    },
    orderForm: {},
    subCompanies: [],
    calculateParameter: 166.67,
    transferType: 2,
    searching: true,
    searchResults: [],
    selectedSearchResult: null,
    confirmation: {
      onConfirm: () => {},
      visible: false,
    },
    airports: [],
    fastShippingSearchId: null,

    stepper: 1,

    // Subcompany
    phonePrefix: null,

    sourceCompanies: [],
    carrierInfo: {
      id: '',
      name: '',
      address: '',
      phone: '',
      email: '',
      date: '',
    },
    showCarrierModal: false,
    isCarrierEdit: false,

    filters: {
      StartDate: null,
      EndDate: null,
      OrderStatus: null,
      PaymentStatus: null,
      TransportType: null,
      HasBoxes: null,
      CompanyName: null,
      RefNo: null,
      TrackingNo: null,
      From: null,
      To: null,
      Id: null,
      IsCourierExits: null,
      OrderType: null
    },

    supplierCarrier: {},
  }),
  components: {
    QuickCreateOrder,
    RefreshButton,
    BlockUser,
    FormElement,
    AddVolume,
    ConfirmationModal,
  },
  async mounted() {

    this.cancelReasons = [
      {
        name: this.$t('labels.Other'),
        value: 0,
      },
      {
        name: this.$t('labels.ConfirmationNotRecived'),
        value: 1,
      },
      {
        name: this.$t('labels.DocumentsMissing'),
        value: 2,
      },
      {
        name: this.$t('labels.InformationChanged'),
        value: 3,
      },
      {
        name: this.$t('labels.PaymentNotReceived'),
        value: 4,
      },
      {
        name: this.$t('labels.DeliveryProblems'),
        value: 5,
      },
    ];

    this.isSupplier =
      this.$store.state.Type === 'Supplier' ||
      this.$store.state.Type === 'PendingSupplier';

    this.isAdmin = this.$store.state.Type === 'Admin';

    this.shipmentTypes = [
      {
        name: this.$t('labels.All'),
        value: null,
      },
      {
        name: this.$t('labels.cargo'),
        value: 1,
      },
      {
        name: this.$t('labels.express'),
        value: 2,
      },
    ];

    this.orderStatuses = [
      {
        name: this.$t('labels.All'),
        value: null,
      },
      {
        name: this.$t('labels.labelsOrderStatuses.detail'),
        value: 0,
      },
      {
        name: this.$t('labels.labelsOrderStatuses.payment'),
        value: 2,
      },
      {
        name: this.$t('labels.labelsOrderStatuses.paymentApproved'),
        value: 1,
      },
      {
        name: this.$t('labels.labelsOrderStatuses.approved'),
        value: 3,
      },
      {
        name: this.$t('labels.labelsOrderStatuses.loaded'),
        value: 4,
      },
      {
        name: this.$t('labels.labelsOrderStatuses.shipping'),
        value: 5,
      },
      {
        name: this.$t('labels.labelsOrderStatuses.inDestination'),
        value: 6,
      },
      {
        name: this.$t('labels.labelsOrderStatuses.delivered'),
        value: 7,
      },
      {
        name: this.$t('labels.labelsOrderStatuses.archived'),
        value: 8,
      },
      {
        name: this.$t('labels.labelsOrderStatuses.canceled'),
        value: 9,
      },
    ];
    this.supplierOrderStatuses = [
      {
        name: this.$t('labels.fileStatuses.notPlanned'),
        value: 0,
      },
      {
        name: this.$t('labels.fileStatuses.pickupPlanned'),
        value: 1,
      },
      {
        name: this.$t('labels.fileStatuses.inWarehouse'),
        value: 2,
      },
      {
        name: this.$t('labels.fileStatuses.loading'),
        value: 3,
      },
      {
        name: this.$t('labels.fileStatuses.invoiced'),
        value: 4,
      },
      {
        name: this.$t('labels.fileStatuses.atDestination'),
        value: 5,
      },
      {
        name: this.$t('labels.fileStatuses.delivered'),
        value: 6,
      },
      {
        name: this.$t('labels.labelsOrderStatuses.canceled'),
        value: 9,
      },
    ];
    this.perPageValues.push({
      name: this.$t('labels.All'),
      value: 9999,
    });

    this.userRole = this.$store.getters.getUserType;
    this.setup();
    this.getCountries();
    this.getTableList();

    this.getSourceCompanies();
  },
  computed: {
    supplierCarrierDateRange() {
      return [
        {
          key: {
            parent: 'supplierCarrier',
            child: 'EstimatedCourierDateStart',
          },
          validationLabel: 'labels.startDate',
          rules: 'required',
          topLabel: false,
          labelShown: false,
          formType: {
            name: 'date',
          },
          lg: 6,
          cols: 6,
          placeholder: 'labels.startDate',
        },
        {
          key: {
            parent: 'supplierCarrier',
            child: 'EstimatedCourierDateEnd',
          },
          validationLabel: 'labels.endDate',
          rules: 'required',
          topLabel: false,
          labelShown: false,
          formType: {
            name: 'date',
            minimum: this.supplierCarrier.EstimatedCourierDateStart,
          },
          lg: 6,
          cols: 6,
          placeholder: 'labels.endDate',
        },
      ];
    },
    supplierCarrierInformation() {
      return [
        {
          key: {
            parent: 'supplierCarrier',
            child: 'CarrierName',
          },
          validationLabel: 'labels.supplierCarrier.carrierName',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          lg: 12,
          cols: 12,
          placeholder: 'labels.supplierCarrier.carrierName',
        },
        {
          key: {
            parent: 'supplierCarrier',
            child: 'CarrierPhone',
          },
          rules: phone,
          validationLabel: 'labels.phone',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          lg: 12,
          cols: 12,
          placeholder: 'labels.phone',
        },
        {
          key: {
            parent: 'supplierCarrier',
            child: 'CarrierNumberPlate',
          },
          validationLabel: 'labels.supplierCarrier.plateNumber',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          lg: 12,
          cols: 12,
          placeholder: 'labels.supplierCarrier.plateNumber',
        },
      ];
    },
    // Filter Form Items
    filters_formItems() {
      return [
        {
          key: {
            parent: 'filters',
            child: 'TrackingNo',
          },
          validationLabel: 'titles.integration.trackingNumber',
          formLabel: 'titles.integration.trackingNumber',
          formType: {
            name: 'text',
            dense: true,
            appendIcon: 'mdi-magnify',
            appendClick: this.getSearchDebounced,
          },
          cols: 6,
          sm: 4,
          md: 3,
          lg: 2,
          xl: 2,
          placeholder: 'titles.integration.trackingNumber',
          classes: 'mb-1 mb-sm-0',
        },
        {
          key: {
            parent: 'filters',
            child: 'RefNo',
          },
          validationLabel: 'labels.referenceNumber',
          formLabel: 'labels.referenceNumber',
          formType: {
            name: 'text',
            dense: true,
            appendIcon: 'mdi-magnify',
            appendClick: this.getSearchDebounced,
          },
          cols: 6,
          sm: 4,
          md: 3,
          lg: 2,
          xl: 2,
          placeholder: 'labels.referenceNumber',
          classes: 'mb-1 mb-sm-0',
        },
        {
          key: {
            parent: 'filters',
            child: 'CompanyName',
          },
          validationLabel: 'labels.companyName',
          formLabel: 'labels.companyName',
          formType: {
            name: 'text',
            dense: true,
            appendIcon: 'mdi-magnify',
            appendClick: this.getSearchDebounced,
          },
          cols: 6,
          sm: 4,
          md: 3,
          lg: 2,
          xl: 2,
          placeholder: 'labels.companyName',
          classes: 'mb-1 mb-sm-0',
        },
        {
          active: !this.isSupplier,
          key: {
            parent: 'filters',
            child: 'Source',
          },
          validationLabel: 'labels.sourceCompany',
          formLabel: 'labels.sourceCompany',
          formType: {
            name: 'multipleSelect',
            dense: true,
            items: {
              data: this.sourceCompanies,
              text: 'Name',
              value: 'Id',
              disableAutoSelection: true,
            },
            appendIcon: 'mdi-magnify',
            appendClick: this.getSearchDebounced,
          },
          onChange: this.getSearchDebounced,
          cols: 6,
          sm: 4,
          md: 3,
          lg: 2,
          xl: 2,
          placeholder: 'labels.sourceCompany',
          classes: 'mb-1 mb-sm-0',
        },
        {
          key: {
            parent: 'filters',
            child: 'TransportType',
          },
          validationLabel: 'labels.shipmentType',
          formLabel: 'labels.shipmentType',
          formType: {
            name: 'select',
            dense: true,
            items: {
              data: this.shipmentTypes,
              text: 'name',
              value: 'value',
            },
            onChange: this.filterContent,
          },
          cols: 6,
          sm: 4,
          md: 3,
          lg: 2,
          xl: 2,
          placeholder: 'labels.shipmentType',
          classes: 'mb-1 mb-sm-0',
        },
        {
          key: {
            parent: 'filters',
            child: 'From',
          },
          validationLabel: 'titles.from',
          formLabel: 'titles.from',
          formType: {
            name: 'multipleSelect',
            dense: true,
            items: {
              data: this.countryItems,
              text: 'Name',
              value: 'Id',
            },
            onChange: this.filterContent,
          },
          cols: 6,
          sm: 4,
          md: 3,
          lg: 2,
          xl: 2,
          placeholder: 'titles.from',
          classes: 'custom-border',
        },
        {
          key: {
            parent: 'filters',
            child: 'To',
          },
          validationLabel: 'titles.to',
          formLabel: 'titles.to',
          formType: {
            name: 'multipleSelect',
            dense: true,
            items: {
              data: this.countryItems,
              text: 'Name',
              value: 'Id',
            },
            onChange: this.filterContent,
          },
          cols: 6,
          sm: 4,
          md: 3,
          lg: 2,
          xl: 2,
          placeholder: 'titles.to',
          classes: 'custom-border',
        },
        {
          key: {
            parent: 'filters',
            child: 'OrderStatus',
          },
          validationLabel: 'labels.orderStatus',
          formLabel: 'labels.orderStatus',
          formType: {
            name: 'select',
            dense: true,
            items: {
              data: this.orderStatuses,
              text: 'name',
              value: 'value',
            },
            onChange: this.filterContent,
          },
          cols: 6,
          sm: 4,
          md: 3,
          lg: 2,
          xl: 2,
          placeholder: 'labels.orderStatus',
          classes: 'custom-border',
          active: !this.isSupplier,
        },
        {
          key: {
            parent: 'filters',
            child: 'SupplierOrderStatus',
          },
          validationLabel: 'labels.fileStatus',
          formLabel: 'labels.fileStatus',
          formType: {
            name: 'select',
            dense: true,
            items: {
              data: this.supplierOrderStatuses,
              text: 'name',
              value: 'value',
            },
            onChange: this.filterContent,
          },
          cols: 6,
          sm: 4,
          md: 3,
          lg: 2,
          xl: 2,
          placeholder: 'labels.fileStatus',
          classes: 'custom-border',
          active: this.isSupplier,
        },
        {
          key: {
            parent: 'filters',
            child: 'IsCourierExits',
          },
          validationLabel: 'IsCourierExits',
          formLabel: 'IsCourierExits',
          formType: {
            name: 'select',
            dense: true,
            items: {
              data: [
                {
                  Text: this.$t('labels.All'),
                  Value: null,
                },
                {
                  Text: this.$t('labels.isCourierExitsTrue'),
                  Value: true,
                },
                {
                  Text: this.$t('labels.isCourierExitsFalse'),
                  Value: false,
                },
              ],
              text: 'Text',
              value: 'Value',
            },
            onChange: this.filterContent,
          },
          cols: 6,
          sm: 4,
          md: 3,
          lg: 2,
          xl: 2,
          placeholder: 'titles.isCourierExits',
          classes: 'custom-border',
        },
        {
          key: {
            parent: 'filters',
            child: 'StartDate',
          },
          validationLabel: 'labels.startDate',
          formLabel: 'labels.startDate',
          formType: {
            name: 'date',
            dateMode: 'date',
            dense: true,
            onChange: this.filterContent,
          },
          cols: 6,
          sm: 4,
          md: 2,
          lg: 2,
          xl: 2,
          placeholder: 'labels.startDate',
          classes: 'custom-border',
        },
        {
          key: {
            parent: 'filters',
            child: 'EndDate',
          },
          validationLabel: 'labels.endDate',
          formLabel: 'labels.endDate',
          formType: {
            name: 'date',
            dateMode: 'date',
            dense: true,
            onChange: this.filterContent,
          },
          cols: 6,
          sm: 4,
          md: 2,
          lg: 2,
          xl: 2,
          placeholder: 'labels.endDate',
          classes: 'custom-border',
        },
        {
          key: {
            parent: 'filters',
            child: 'OrderType',
          },
          validationLabel: 'titles.orderType',
          formLabel: 'titles.orderType',
          formType: {
            name: 'select',
            dense: true,
            items: {
              data: [
                {
                  value: null,
                  text: this.$t('labels.allGroupTypes')
                }, ...this.$orderTypes],
                text: 'text',
                value: 'value',
            },
            onChange: this.filterContent,
          },
          cols: 6,
          sm: 4,
          md: 3,
          lg: 2,
          xl: 2,
          placeholder: 'titles.orderType',
          classes: 'mb-1 mb-sm-0',
        },
      ];
    },
    carrierFormDateRange() {
      return [
        {
          key: {
            parent: 'carrierInfo',
            child: 'desiredCourierDateStart',
          },
          validationLabel: 'labels.startDate',
          rules: 'required',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'date',
          },
          lg: 6,
          cols: 6,
          placeholder: 'labels.startDate',
        },
        {
          key: {
            parent: 'carrierInfo',
            child: 'desiredCourierDateEnd',
          },
          validationLabel: 'labels.endDate',
          rules: 'required',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'date',
            minimum: this.carrierInfo.desiredCourierDateStart,
          },
          lg: 6,
          cols: 6,
          placeholder: 'labels.endDate',
        },
      ];
    },
    carrierFormItems() {
      return [
        {
          key: {
            parent: 'carrierInfo',
            child: 'name',
          },
          rules: company,
          validationLabel: 'labels.companyName',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          lg: 12,
          cols: 12,
          placeholder: 'labels.companyName',
        },
        {
          key: {
            parent: 'carrierInfo',
            child: 'address',
          },
          rules: 'required',
          validationLabel: 'labels.address1',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'textarea',
          },
          lg: 12,
          cols: 12,
          placeholder: 'labels.address1',
        },
        {
          key: {
            parent: 'carrierInfo',
            child: 'phone',
          },
          rules: rules.phone,
          validationLabel: 'labels.phone',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
            prefix: this.phonePrefix,
            autocomplete: 'new-password',
          },
          lg: 6,
          cols: 6,
          placeholder: 'labels.phone',
        },
        {
          key: {
            parent: 'carrierInfo',
            child: 'email',
          },
          validationLabel: 'labels.email',
          rules: 'required|email|max:50',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          lg: 6,
          cols: 6,
          placeholder: 'labels.email',
        },
      ];
    },

    pages() {
      if (this.rowsPerPage == null || this.totalItems == null) {
        return 0;
      }
      return Math.ceil(this.totalItems / this.rowsPerPage);
    },
  },
  methods: {
    submitCarrier() {
      if (this.isCarrierEdit) {
        this.editCarrier();
      } else {
        this.addCarrier();
      }
    },
    addCarrier() {
      this.$store.state.loadingStatus = true;
      const body = {
        ShipmentId: this.carrierInfo.id,
        CompanyName: this.carrierInfo.name,
        PickupAddress: this.carrierInfo.address,
        Phone: this.carrierInfo.phone,
        Email: this.carrierInfo.email,
        DesiredCourierDateStart: this.carrierInfo.desiredCourierDateStart,
        DesiredCourierDateEnd: this.carrierInfo.desiredCourierDateEnd,
      };

      CarrierService.addCarrier(body)
        .then((res) => {
          this.resetCarrierModal();
          window.showSuccess(this.$t('description.carrierAdded'));
        })
        .catch((err) => {
          window.handleServiceError(err);
        })
        .finally(() => {
          this.$store.state.loadingStatus = false;
          this.getTableList();
        });
    },

    editCarrier() {
      this.$store.state.loadingStatus = true;
      const body = {
        Id: this.carrierInfo.id,
        CompanyName: this.carrierInfo.name,
        PickupAddress: this.carrierInfo.address,
        Phone: this.carrierInfo.phone,
        Email: this.carrierInfo.email,
        DesiredCourierDateStart: this.carrierInfo.desiredCourierDateStart,
        DesiredCourierDateEnd: this.carrierInfo.desiredCourierDateEnd,
      };

      CarrierService.editCarrier(body)
        .then((res) => {
          this.resetCarrierModal();
          window.showSuccess(this.$t('description.carrierUpdated'));
        })
        .catch((err) => {
          window.handleServiceError(err);
        })
        .finally(() => {
          this.$store.state.loadingStatus = false;
          this.getTableList();
        });
    },

    resetCarrierModal() {
      this.carrierInfo = {
        id: null,
        name: null,
        address: null,
        phone: null,
        email: null,
        desiredCourierDateStart: null,
        desiredCourierDateEnd: null,
      };
      this.isCarrierEdit = false;
      this.showCarrierModal = false;
      this.$refs.carrierModalObserver.reset();
    },
    callCarrier(item) {
      if (item.CourierInformation) {
        const {
          EstimatedCourierDateStart,
          EstimatedCourierDateEnd,
          CarrierName,
          CarrierPhone,
          CarrierNumberPlate,
        } = item.CourierInformation;
        this.supplierCarrier = {
          EstimatedCourierDateStart,
          EstimatedCourierDateEnd,
          CarrierName,
          CarrierPhone,
          CarrierNumberPlate,
        };

        this.carrierInfo.id = item.CourierInformation.Id;
        this.carrierInfo.name = item.CourierInformation.CompanyName;
        this.carrierInfo.address = item.CourierInformation.PickupAddress;
        this.carrierInfo.phone = item.CourierInformation.Phone;
        this.carrierInfo.email = item.CourierInformation.Email;
        this.carrierInfo.desiredCourierDateStart =
          item.CourierInformation.DesiredCourierDateStart + 'Z';
        this.carrierInfo.desiredCourierDateEnd =
          item.CourierInformation.DesiredCourierDateEnd + 'Z';

        this.isCarrierEdit = true;
      } else {
        this.carrierInfo.id = item.ShipmentId;
      }

      this.showCarrierModal = true;
    },
    triggerCancelOrder(order) {
      this.selectedOrder = order;
      this.cancelOrderModal = true;
    },
    cancelOrder() {
      this.$store.state.loadingStatus = true;
      const body = {
        OrderId: this.selectedOrder.Id,
        CancelReason: this.selectedReason,
        CancelDescription: this.cancelDescription,
      };
      
      OrderService.cancelOrder(body)
        .then((res) => {
          this.resetCancelModal();
          this.getTableList();
          window.showSuccess(this.$t('description.orderCanceled'));
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    resetCancelModal() {
      this.cancelOrderModal = false;
      this.selectedReason = null;
      this.cancelDescription = '';
      this.$refs.cancelModalObserver.reset();
    },
    async getSourceCompanies() {
      this.$store.state.loadingStatus = true;
      CompanyServices.getSourceCompanies()
        .then((response) => {
          this.sourceCompanies = response.data.Result;
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    handleOpenURL() {
      window.open(
        'https://www.ups.com/worldshiphelp/WSA/ENU/AppHelp/mergedProjects/CORE/Codes/State_Province_Codes.htm',
        '_blank'
      );
    },

    getSearchDebounced() {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.rowsPerPage = 15;
        this.itemsPerPage = 15;
        this.page = 1;
        this.getTableList();
      }, 300);
    },
    resetFilter() {
      this.filters = { ...INITIAL_FILTERS };
      this.filterContent();
    },
    downloadTag(item) {
      this.$store.state.loadingStatus = true;
      let string = item.RefNo + '_Labels';
      OrderService.downloadTag(item.Id, string).then(() => {
        this.$store.state.loadingStatus = false;
      });
    },
    toggleArchive(item) {
      const body = {
        OrderId: item.Id,
      };
      OrderService.archiveOrder(body).then((res) => {
        this.getTableList();
      });
    },
    goToPayments() {
      this.$router.push('/home/payments');
    },
    changeItemsPerPage() {
      this.page = 1;
      this.options.itemsPerPage = this.rowsPerPage;
      this.getTableList();
    },
    paginationChangeHandler(pageNumber) {
      this.page = pageNumber;
      this.getTableList();
    },
    async getCountries() {
      this.countryItems = await getCountries();
    },
    setup() {
      this.headers = [
        {
          text: this.$t('titles.integration.trackingNumber'),
          value: 'TrackingNo',
          sortable: true,
          align: 'center',
        },
        {
          text: this.$t('labels.customer'),
          value: 'Customer',
          sortable: true,
          groupable: false,
          align: 'center',
        },

        {
          text: this.$t('labels.supplier'),
          value: 'Carrier',
          sortable: true,
          groupable: false,
          align: 'center',
        },
        {
          text: this.$t('labels.source'),
          value: 'Source',
          sortable: true,
          groupable: false,
          align: 'center',
        },
        {
          text: this.$t('labels.sender'),
          value: 'Sender',
          sortable: true,
          groupable: false,
          align: 'center',
        },

        {
          text: this.$t('labels.shipmentType'),
          value: 'ShipmentType',
          sortable: true,
          align: 'center',
        },
        {
          text: this.$t('titles.from') + '/' + this.$t('titles.to'),
          value: 'FromToWhere',
          sortable: false,
          align: 'center',
        },

        {
          text: this.$t('labels.referenceNumber'),
          value: 'RefNo',
          sortable: true,
          align: 'center',
        },
        {
          text: this.$t('labels.dateAsNoun'),
          value: 'CreatedOnUtc',
          sortable: false,
          align: 'center',
        },
        {
          text: this.$t('labels.orderStatus'),
          value: 'OrderStatus',
          sortable: true,
          align: 'center',
        },
        {
          text: this.$t('labels.fileStatus'),
          value: 'SupplierOrderStatus',
          sortable: true,
          align: 'center',
        },
        {
          text: this.$t('labels.paymentStatus'),
          value: 'PaymentStatus',
          sortable: true,
          align: 'center',
        },
        {
          text: this.$t('titles.orderType'),
          value: 'OrderType',
          sortable: true,
          align: 'center',
        },
        {
          text: this.$t('labels.chargeableWeight'),
          value: 'ChargeableWeight',
          sortable: true,
          align: 'center',
        },
        {
          text: this.$t('labels.price'),
          value: 'Price',
          sortable: true,
          align: 'end',
        },
        {
          text: this.$t('title.tableHeaderActions'),
          value: 'actions',
          sortable: false,
        },
      ];

      if (this.userRole === 'Customer' || this.userRole === 'PendingCustomer') {
        this.headers = this.headers.filter(
          (header) =>
            header.value !== 'Customer' &&
            header.value !== 'SupplierOrderStatus' &&
            header.value !== 'PaymentStatus'
        );
      } else if (
        this.userRole === 'Supplier' ||
        this.userRole === 'PendingSupplier'
      ) {
        this.headers = this.headers.filter(
          (header) =>
            header.value !== 'Carrier' &&
            header.value !== 'OrderStatus' &&
            header.value !== 'Source' &&
            header.value !== 'PaymentStatus'
        );
      } else if (this.isAdmin) {
        this.headers = this.headers.filter(
          (header) => header.value !== 'actions' && header.value !== 'actions'
        );
      }
    },
    goOrderDetail(item) {
      openRouteInNewTab({
        name: `OrderDetail`,
        query: {
          orderId: item.Id,
        },
        params: {
          transportType: item.TransportType,
        },
      });
    },
    goRateScreen(item) {
      this.$router.push({
        name: `rateOrder`,
        params: {
          order: item,
        },
      });
    },
    filterContent() {
      this.tableData = [];
      this.rowsPerPage = 15;
      this.itemsPerPage = 15;
      this.page = 1;
      this.getTableList();
    },

    getTableList() {
      this.$store.state.loadingStatus = true;
      const { StartDate, EndDate, ...others } = this.filters;
      OrderService[this.isAdmin ? 'getListForAdmin' : 'getOrders']({
        Page: this.page,
        PageSize: this.rowsPerPage,
        StartDate: StartDate ? extractDateFromObject(StartDate) : null,
        EndDate: EndDate ? extractDateFromObject(EndDate) : null,
        ...others,
      })
        .then((res) => {
          this.tableData = res.data.Result == null ? [] : res.data.Result;
          this.totalItems = res.data.TotalItems;
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    async messageToUser(id) {
      this.$store.state.loadingStatus = true;
      await MessageServices.getById(id)
        .then(async (response) => {
          const data = response.data.Result;
          let chatId = data.Id;
          if (chatId) {
            this.$router.push({
              name: 'messageDetail',
              query: {
                id: chatId,
              },
            });
          }
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },
  },
};
</script>
